<template>
  <q-dialog
    v-model="dialog"
    style="max-width: 500px"
    persistent
    class="custom-font text-uppercase"
    maximized
  >
    <q-card class="full-width pragma-black text-white">
      <q-form @submit.prevent="rendir()">
        <q-card-section class="text-center text-white">
          <div class="row">
            <div class="col-xs-2">
              <q-btn round color="white" icon="arrow_back" class="bg-pragma" @click="closeDialog()" />
            </div>
            <div class="col-xs-8">
              <span class="text-h6 text-bold">Rendir solicitud</span>
            </div>
            <div class="col-xs-2">
              <q-btn round color="purple" @click="imprimirRendicion()" v-if="tab == 'documentos'">
                <q-icon name="picture_as_pdf"></q-icon>
              </q-btn>
            </div>
          </div>
        </q-card-section>
        <q-separator class="bg-pragma"/>
        <q-card-section class="q-pa-none">
          <q-tabs
            v-model="tab"
            dense
            class="text-grey"
            active-color="white"
            indicator-color="white"
            align="justify"
          >
            <q-tab name="solicitud" label="Solicitud" />
            <q-tab name="items" label="Items" />
            <q-tab name="documentos" label="Documentos" />
            <q-tab name="devoluciones" label="Devoluciones" />
          </q-tabs>
          <q-separator />
          <q-tab-panels v-model="tab" animated>
            <q-tab-panel name="solicitud" class="pragma-black text-white">
              <tab-solicitud :solicitud="solicitud"/>
            </q-tab-panel>

            <q-tab-panel name="items" class="pragma-black text-white">
              <tab-items :items="items" :items_rendidos="items_rendidos" :solicitud="solicitud" :amounts="amounts"/>
            </q-tab-panel>

            <q-tab-panel name="documentos" class="pragma-black text-white">
              <tab-documentos :documentos="documentos" :solicitud="solicitud"/>
            </q-tab-panel>

            <q-tab-panel name="devoluciones" class="pragma-black text-white">
              <tab-devoluciones :devoluciones="devoluciones" :solicitud="solicitud" :items="items"/>
            </q-tab-panel>

          </q-tab-panels>
        </q-card-section>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import {inject, ref} from 'vue'
import axios from 'axios'
import env from '../../../../config/env'
import TabSolicitud from '../components/TabSolicitud.vue'
import TabDocumentos from '../components/TabDocumentos.vue'
import TabDevoluciones from '../components/TabDevoluciones.vue'
import TabItems from '../components/TabItems.vue'

export default {
  components: {
    TabSolicitud,
    TabDocumentos,
    TabDevoluciones,
    TabItems
  },
  setup () {
    // Deficición de variables
    const bus = inject('bus')

    const dialog = ref(false)
    const solicitud = ref(null)
    const loading = ref(false)
    const tab = ref('solicitud')
    const documentos = ref([])
    const devoluciones = ref([])
    const items = ref([])
    const items_rendidos = ref([])

    const amounts = ref({
      total_desembolso: 0,
      total_rendido: 0,
      favor_solicitante: 0,
      favor_empresa: 0
    })

    // Métodos y funciones
    const getRendicion = async (solicitud_id) => {
      try {
        let res = await axios.get(`json/datos_solicitud/${solicitud_id}`)
        solicitud.value = res.data
        res = await axios.get(`rendir/solicitud/${solicitud_id}`)
        items.value = res.data.items
        items_rendidos.value = res.data.items_rendidos
        documentos.value = res.data.doc_rendidos
        devoluciones.value = res.data.devoluciones
        amounts.value.total_desembolso = res.data.extras.total_desembolso
        amounts.value.total_rendido = res.data.extras.total_rendido
        amounts.value.favor_solicitante = res.data.extras.favor_solicitante
        amounts.value.favor_empresa = res.data.extras.favor_empresa
      } catch (error) {
        console.log(error)
      }
    }

    const closeDialog = () => {
      loading.value = false
      tab.value = 'solicitud'
      dialog.value = false
    }

    const rendir = async () => {
      console.log('rendir')
    }

    const imprimirRendicion = () => {
      window.open(`${env.API_URL}solicitud-documentos/rendicion/generar/${solicitud.value.id}`)
    }

    // Creación del componente
    bus.on('openDialogRendirSolicitud', (item) => {
      solicitud.value = item
      getRendicion(item.id)
      dialog.value = true
    })
    bus.on('refreshRendicion', () => {
      getRendicion(solicitud.value.id)
    })

    bus.on('closeTabItems', () => {
      bus.emit('closeDialogModificarSolicitud')
      closeDialog()
    })
    // Variables
    return {
      dialog,
      closeDialog,
      rendir,
      loading,
      tab,
      solicitud,
      documentos,
      devoluciones,
      items,
      items_rendidos,
      amounts,
      imprimirRendicion
    }
  }
}
</script>

<style>

</style>